import {Injectable} from '@angular/core';
import {localStorageGet} from '../../helper/typed-local-storage';

@Injectable()
export abstract class AbstractTableComponent {
    public pageSize = parseInt(localStorageGet('DEFAULT_LIST_ENTRIES_COUNT', "20"), 10);
    public pageIndex = 0;
    public pageSizeOptions = [10, 25, 50, 100, 250];
}
